// extracted by mini-css-extract-plugin
module.exports = {"blog":"BlogForm_blog__0ZAzJ","tableContent":"BlogForm_tableContent__VK9MD","skeleton":"BlogForm_skeleton__ktoAO","skeleton-animation":"BlogForm_skeleton-animation__YE7TF"};